import { Close } from "@mui/icons-material";
import { Alert, FormControlLabel, Radio } from "@mui/material";
import React from "react";
import {
  DocumentationInput,
  DocumentationInputValue,
  useDocumentationInput,
} from "./DocumentationInput";
import { ExternalLink } from "../../../../common/components/ExternalLink";

export const FILE_TYPE_UPLOADED = "file_type_uploaded";
export const FILE_TYPE_URL = "file_type_url";

type RadioWithDocumentInputProps = {
  label: string | React.ReactNode;
  value: string | number | null;
  initialValue?: DocumentationInputValue | null;
  onDocumentChanged?: (
    value: DocumentationInputValue,
    prevValue: DocumentationInputValue,
  ) => Promise<void>;
  onRadioChanged?: (e: React.SyntheticEvent<Element, Event>, checked: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
  selected?: boolean;
  createFileLink?: (fileKey: string) => string;
};

export const RadioWithDocumentInput: React.FC<RadioWithDocumentInputProps> = ({
  label,
  value,
  onDocumentChanged,
  onRadioChanged,
  disabled = false,
  loading = false,
  initialValue = null,
  selected = false,
  createFileLink,
}) => {
  const {
    value: fileValue,
    clear: clearUserInput,
    error,
    props: inputProps,
  } = useDocumentationInput({
    initialValue,
    onChange: onDocumentChanged,
  });

  return (
    <>
      <FormControlLabel
        value={value}
        control={<Radio color="primary" />}
        onChange={onRadioChanged}
        label={
          <div className="d-flex align-items-center">
            <div>{label}</div>
            {selected && (
              <div className="ml-md flex-grow">
                <DocumentationInput
                  disabled={disabled || loading || !selected}
                  {...inputProps}
                  variant="inline"
                />
                {Boolean(error) && (
                  <Alert className="mt-sm" color="error">
                    {error.error}
                  </Alert>
                )}
              </div>
            )}
            {selected && fileValue?.type == "file" && fileValue.fileKey && (
              <div className="d-flex align-items-start w-100">
                {createFileLink ? (
                  <ExternalLink
                    icon={false}
                    className="text-t1 text-weight-medium"
                    href={createFileLink(fileValue.fileKey)}
                  >
                    <span className="max-width-192 text-ellipsis">{fileValue.fileName}</span>
                  </ExternalLink>
                ) : (
                  <span className="max-width-192 text-ellipsis">{fileValue.fileName}</span>
                )}
                <Close
                  fontSize="inherit"
                  className="ml-xxs mt-xxxs cursor-pointer"
                  onClick={() => clearUserInput()}
                />
              </div>
            )}
          </div>
        }
        disabled={disabled || loading}
        className="radio-with-text-field"
      />
    </>
  );
};
